'use client'

import { Text } from '@components/primitives/Text'
import { faCapsules } from '@fortawesome/pro-regular-svg-icons/faCapsules'
import { isNotEmptyOrSkippedAnswer } from '@modules/patientApplyProfile/helpers/PatientApplyProfileData'
import { useState } from 'react'
import { PopularItemsCheckbox } from './PopularItemsCheckbox.client'
import { SelectedItems } from './SelectedItems.client'
import { STRUCTURED_QUESTION_NONE } from './const'
import type { ConditionCollectElementProps } from './types'

const substancesToDisplayToPatient = [
  { displayName: 'Alcohol', value: 'Alcohol' },
  { displayName: 'Marijuana', value: 'Marijuana' },
  { displayName: 'Tobacco', value: 'Tobacco' },
  { displayName: 'Cocaine', value: 'Cocaine' },
  { displayName: 'Benzodiazepines', value: 'Benzodiazepines' },
  { displayName: 'Methamphetamine', value: 'Methamphetamine' },
  { displayName: 'MDMA', value: 'MDMA' },
  { displayName: 'LSD', value: 'LSD' },
  { displayName: 'Magic Mushroom', value: 'Magic Mushroom' },
  { displayName: 'Heroin', value: 'Heroin' },
  { displayName: 'Ecstasy', value: 'Ecstasy' },
  { displayName: 'Ketamine', value: 'Ketamine' },
  { displayName: 'PCP', value: 'PCP' },
  { displayName: 'GHB', value: 'GHB' },
  {
    displayName: 'I am not taking any of these substances',
    value: STRUCTURED_QUESTION_NONE,
  },
]
export default function CollectCurrentSubstances({
  patientProfileData,
}: ConditionCollectElementProps) {
  const [currentSubstances, setCurrentSubstances] = useState(
    patientProfileData.currentSubstances.filter(isNotEmptyOrSkippedAnswer),
  )

  const handleUpdatedSelectedCurrentMedications = (substanceName: string) => {
    if (currentSubstances.includes(substanceName)) {
      setCurrentSubstances(
        currentSubstances.filter((name) => name !== substanceName),
      )
    } else {
      setCurrentSubstances([...currentSubstances, substanceName])
    }
  }

  return (
    <div className='flex w-full flex-col gap-4'>
      <Text
        className='text-neutral900'
        element='p'
        styleName='h3'
        value='Which of these substances have you used in the past 6-months?'
      />

      <div className='flex flex-col gap-10 md:flex-row'>
        <div className='order-1 w-full gap-2 md:order-2 md:w-1/4'>
          <SelectedItems
            icon={faCapsules}
            onChange={setCurrentSubstances}
            title='Selected Substances'
            trackingType='currentSubstance'
            value={currentSubstances}
          />

          {currentSubstances.filter(Boolean).map((currentSubstance) => (
            <input
              key={currentSubstance}
              name={'currentSubstances'}
              type='hidden'
              value={currentSubstance}
            />
          ))}
        </div>
        <div className='order-2 flex w-full flex-col gap-2 md:order-1 md:w-3/5'>
          <Text
            className='text-neutral900'
            element='p'
            styleName='p-small'
            value='Select all that apply'
          />

          <div className='minimal-scrollbar h-96 overflow-y-scroll'>
            {substancesToDisplayToPatient.map((item) => (
              <PopularItemsCheckbox
                handleUpdatedSelectedItems={handleUpdatedSelectedCurrentMedications.bind(
                  null,
                  item.value,
                )}
                isSelected={currentSubstances.includes(item.value)}
                item={item}
                key={item.value}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
